import { render } from "./DashboardNavLeftLink.vue?vue&type=template&id=1ae471c4&scoped=true&ts=true&lang=pug"
import script from "./DashboardNavLeftLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardNavLeftLink.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardNavLeftLink.vue?vue&type=style&index=0&id=1ae471c4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae471c4"]])

export default __exports__